var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"https://wa.me/5551983599666","target":"_blank","title":"Fale com a gente pelo WhatsApp"}},[_c('v-icon',{class:_vm.isDashboard ? 'text-white' : 'text-primary',staticStyle:{"margin-top":"-6px"},attrs:{"scale":_vm.scale,"name":"brands/whatsapp"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }